import React, { Component } from 'react';
import './App.css';
import { fetchApplications, fetchVersions } from './Client';
import VersionsTable from './VersionsTable';
import { DangerAlert } from './Common';
import { useLocation } from "react-router-dom";
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'bootstrap/dist/css/bootstrap.css';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function App() {
    const id = useQuery().get('id');
    return (
        <div className='App'>
            <Content applicationId={id} />
        </div>);
}

class Content extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'applications':[],
            'versions':[],
            'task':null,
            'retry':null,
            'error':null
        };
        this.onApplicationChange = this.onApplicationChange.bind(this);
    }
    
    render() {
        return (
            <div>
                <nav className='navbar navbar-dark bg-primary navbar-fixed-top'>
                    <span className='navbar-brand'>Revision History</span>
                    <ApplicationSelect
                        applicationId={this.props.applicationId}
                        applications={this.state.applications}
                        onApplicationChange={this.onApplicationChange}/>
                </nav>
                <Error
                    task={this.state.task}
                    details={this.state.error}
                    retry={this.state.retry}/>
                <VersionsTable versions={this.state.versions} />
            </div>
        );
    }

    componentDidMount() {
        this.populateApplications();
    }

    onApplicationChange(applicationId) {
        this.populateVersions(applicationId);
    }

    populateApplications() {
        const action = () => fetchApplications(
            (data) => {
                this.setState({
                    'applications':data.sort((a, b) => a.name > b.name ? 1 : -1),
                    'error':null
                });
                this.onApplicationChange(this.props.applicationId
                    ? this.props.applicationId
                    : data.length > 0
                        ? data[0].id
                        : 0);
            },
            (error) => this.setState({'error':error.message}));
        this.setState({
            'task':'fetching applications',
            'retry':action
        });
        action();
    }

    populateVersions(applicationId) {
        const action = () => fetchVersions(
            applicationId,
            (data) => this.setState({
                'versions':data.sort((a, b) => Date.parse(a.date) < Date.parse(b.date) ? 1 : -1),
                'error':null
            }),
            (error) => this.setState({'error':error.message}));
        this.setState({
            'task':'fetching versions',
            'retry':action
        });
        action();
    }
}

function ApplicationSelect(props) {
    const app = props.applications.filter(n => n.id === props.applicationId).pop();
    if (app) return (<div className='form-inline'><label>{app.name}</label></div>);
    return (
        <div className='form-inline'>
            <label>Application</label>
            <select
                id='applicationSelect'
                value={props.applicationId}
                className='form-control'
                onChange={ev => props.onApplicationChange(ev.target.value)}
                disabled={props.applicationId ? true : false}>
                {props.applications.map((app) =>
                    <option value={app.id} key={app.id}>{app.name}</option>
                )}
            </select>
        </div>);
}

function Error(props) {
    if (!props.details) return (<span></span>);
    return(
        <div className='container-fluid'>
            <DangerAlert
                title={'Something went wrong while ' + props.task + '!'}
                details={props.details}
                actionTitle='Try Again'
                action={props.retry} />
        </div>);
}

export default App;
